export interface NavigationItem {
	id: string;
	title: string;
	type: 'item' | 'collapse' | 'group';
	translate?: string;
	icon?: string;
	hidden?: boolean;
	url?: string;
	classes?: string;
	external?: boolean;
	target?: boolean;
	breadcrumbs?: boolean;
	children?: NavigationItem[];
	role_ids?: number[];
	urlPattern?: string;
}

const NavigationItems: NavigationItem[] = [
	{
		id: 'vms-dashboard',
		title: 'nav.dashboard',
		type: 'group',
		icon: 'fas fa-home',
		classes: 'first-group',
		children: [
			{
				id: 'dashboard',
				title: 'nav.home',
				type: 'item',
				classes: 'nav-item',
				url: '/dashboard',
				icon: 'fas fa-home',
				breadcrumbs: false,
				role_ids: []
			}
		]
	},
	{
		id: 'panel',
		title: 'nav.panel',
		type: 'group',
		icon: 'fas fa-location-arrow',
		children: [
			{
				id: 'users',
				title: 'nav.users',
				type: 'item',
				classes: 'nav-item',
				url: '/users',
				icon: 'fas fa-user',
				breadcrumbs: true,
				children: [
					{
						id: 'add-user',
						title: 'users.add_user',
						type: 'item',
						url: '/users/create'
					},
					{
						id: 'edit-user',
						title: 'users.edit_user',
						type: 'item',
						urlPattern: '^/users/edit/\\d+$'
					}
				]
			},
			{
				id: 'device-page',
				title: 'devices.device_page',
				type: 'group',
				urlPattern: 'device-page/.*',
				icon: 'fas fa-rss',
				breadcrumbs: true,
				children: [
					{
						id: 'device-settings',
						title: 'devices.device_settings',
						type: 'item',
						urlPattern: 'settings',
					},
					{
						id: 'device-events',
						title: 'devices.events',
						type: 'item',
						urlPattern: 'events',
					},
					{
						id: 'device-define',
						title: 'devices.define',
						type: 'item',
						urlPattern: 'define',
					},
					{
						id: 'system-info',
						title: 'devices.system_info',
						type: 'item',
						urlPattern: 'system-info',
					},
					{
						id: 'cell-info',
						title: 'devices.cell_info',
						type: 'item',
						urlPattern: 'cell-info',
					},
					{
						id: 'cellular-info-track',
						title: 'devices.cell_info',
						type: 'item',
						urlPattern: 'cellular-info-track',
					},
					{
						id: 'device-notes',
						title: 'devices.notes',
						type: 'item',
						urlPattern: 'device-notes'
					},
					{
						id: 'debug-records',
						title: 'devices.debug_records',
						type: 'item',
						urlPattern: 'debug-records'
					},
					{
						id: 'connectivity-track',
						title: 'devices.connectivity_track',
						type: 'item',
						urlPattern: 'connectivity-track'
					},
					{
						id: 'config-track',
						title: 'devices.config_track',
						type: 'item',
						urlPattern: 'config-track'
					},
				]
			},
			{
				id: 'devices_list',
				title: 'nav.devices_list',
				type: 'item',
				classes: 'nav-item',
				urlPattern: '^/devices(?:/(CM|SCT-Inventory|BWT|Demos-and-Engineering))?$',
				icon: 'fas fa-rss',
				breadcrumbs: true,
				children: [
					{
						id: 'edit-device',
						title: 'devices.edit_device',
						type: 'item',
						urlPattern: '/devices/edit/\\d+$'
					},
					{
						id: 'rejection-devices-connection',
						title: 'nav.reject_device_connections_logs',
						type: 'item',
						urlPattern: '/rejected-devices-connection'
					}
				]
			},
			{
				id: 'search-device-details',
				title: 'devices.device_details',
				type: 'item',
				classes: 'nav-item',
				url: '/search-device-details',
				icon: 'fas fa-search',
				breadcrumbs: true,
			},
			{
				id: 'fw-upload',
				title: 'nav.fw_upload',
				type: 'item',
				classes: 'nav-item',
				url: '/fw-upload',
				icon: 'fas fa-network-wired',
				breadcrumbs: true,
			},
			{
				id: 'action-log',
				title: 'nav.action_log',
				type: 'item',
				classes: 'nav-item',
				url: '/action-log',
				icon: 'fas fa-network-wired',
				breadcrumbs: true,
			},
			{
				id: 'api-logs',
				title: 'nav.api_logs',
				type: 'item',
				classes: 'nav-item',
				url: '/api-logs',
				icon: 'fas fa-file',
				breadcrumbs: true,
			},
			{
				id: 'fw-logs',
				title: 'nav.fw_logs',
				type: 'item',
				classes: 'nav-item',
				url: '/fw-logs',
				icon: 'fas fa-file',
				breadcrumbs: true,
			},
			{
				id: 'shipment',
				title: 'nav.shipment',
				type: 'collapse',
				icon: 'fas fa-user',
				breadcrumbs: true,
				children: [
					{
						id: 'receive-shipment',
						title: 'nav.receive_shipment',
						type: 'item',
						url: '/shipment/receive-shipment',
						children: [
							{
								id: 'receive-shipment-history',
								title: 'nav.receive_shipment_history',
								type: 'item',
								url: '/shipment/receive-shipment-history',
							},
						]
					},
					{
						id: 'shipment-quality',
						title: 'nav.shipment_quality',
						type: 'item',
						url: '/shipment/shipment-quality',
						children: [
							{
								id: 'shipment-quality-history',
								title: 'nav.shipment_quality_history',
								type: 'item',
								url: '/shipment/shipment-quality-history',

							},
						]
					},
					{
						id: 'shipping-out',
						title: 'nav.shipping_out',
						type: 'item',
						url: '/shipment/shipping-out',
						children: [
							{
								id: 'shipping-out-history',
								title: 'nav.shipping_out_history',
								type: 'item',
								// Route is registered under `shipping/`, not `shipment/`.
								url: '/shipping/shipping-out-history',
							},
						]
					},
					{
						id: 'orders-management',
						title: 'nav.orders_management',
						type: 'item',
						url: '/shipment/orders-management',
						children: [
							{
								id: 'create-order',
								title: 'nav.create_order',
								type: 'item',
								url: '/shipment/orders-management/create-order',
							},
							{
								id: 'view-order',
								title: 'nav.view_order',
								type: 'item',
								urlPattern: '/shipment/orders-management/view-order/\\d+$',
							},
							{
								id: 'edit-order',
								title: 'nav.edit_order',
								type: 'item',
								urlPattern: '/shipment/orders-management/edit-order/\\d+$',
							}
						]
					}
				]
			},
			{
				id: 'firmware-update',
				title: 'nav.firmware_update',
				type: 'item',
				url: '/firmware-update'
			},
			{
				id: 'user-roles',
				title: 'nav.user_role',
				type: 'item',
				url: '/user-roles',
				children: [
					{
						id: 'create-role',
						title: 'nav.user_role',
						type: 'item',
						url: '/user-roles/create',
					},
					{
						id: 'edit-role',
						title: 'nav.user_role',
						type: 'item',
						url: '/user-roles/edit/\\d+$',
					},
				]
			},
			{
				id: 'cm-fw-versions',
				title: 'nav.cm_fw_versions',
				type: 'item',
				classes: 'nav-item',
				url: '/cm-fw-versions',
				icon: 'fas fa-file',
				breadcrumbs: true,
			},
			{
				id: 'schedule-run',
				title: 'nav.schedule_run',
				type: 'item',
				classes: 'nav-item',
				url: '/schedule-run',
				icon: 'fas fa-file',
				breadcrumbs: true,
			},
			{
				id: 'sim-management',
				title: 'nav.sim_management',
				type: 'item',
				classes: 'nav-item',
				url: '/sim-management/usage',
				icon: 'fas fa-sim-card',
				breadcrumbs: true,
			}
		]
	}
];
export function getNavigationItems() {
	return NavigationItems;
}
